<template>
  <Content @back="$router.back()" key="exportsList">
    <template v-slot:nav_left>
      <p>专家列表</p>
    </template>
    <template v-slot:nav_right>
      <div class="yioks_btn" @click="handleEmptyAction">新增专家</div>
    </template>
    <template v-slot:content_right>
      <div class="base-content-warpper">
        <div class="content-inner-wrapper">
          <div class="select_wrap">
            <div class="select_box left">
              <!-- <el-select
                v-model="filterData.jixiaoType"
                class="y-input"
                clearable
                placeholder=""
                @change="changeQuery(true)"
              >
                <el-option label="全部指标类型" value=""></el-option>
                <el-option
                  v-for="item in performanceGroupTypeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select> -->
            </div>
            <div class="select_box right">
              <input
                v-model.trim="filterData.key"
                type="text"
                class="yioks_input"
                style="width: 160px"
                placeholder="请输入关键字"
                @keyup.enter="changeQuery(true)"
              />
              <div class="yioks_btn" @click="changeQuery(true)">搜索</div>
            </div>
          </div>

          <div class="list_wrap" v-if="!isShowPageLoading && pageList.length">
            <div class="table">
              <div class="thead">
                <div class="tr">
                  <div class="th seq">序号</div>
                  <div class="th name">姓名</div>
                  <div class="th available">状态</div>
                  <div class="th action">操作</div>
                </div>
              </div>
              <div class="scrollArea">
                <vue-scroll>
                  <div class="tbodyWrap">
                    <div class="tbody">
                      <div
                        class="tr"
                        v-for="(item, index) in pageList"
                        :key="index"
                      >
                        <div class="td seq">
                          <p>{{ index + 1 }}</p>
                        </div>
                        <div class="td name">
                          <p>{{ item.idName }}</p>
                        </div>
                        <div class="td available">
                          <p>{{ item.available ? "可用" : "忙碌" }}</p>
                        </div>
                        <div class="td action">
                          <p>
                            <span
                              class="btn suc"
                              @click="
                                handleAllocation(item, 'allocationPerformance')
                              "
                            >分配指标</span
                            >
                            <span class="line m5">|</span>
                            <span
                              class="btn suc"
                              @click="
                                handleAllocation(item, 'allocationSchool')
                              "
                            >分配精英机构/基地</span
                            >
                            <span class="line m5">|</span>
                            <span
                              class="btn err"
                              @click="handleDeleteExport(item)"
                              >解除</span
                            >
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </vue-scroll>
              </div>
            </div>
          </div>
          <template v-if="isShowExportsList">
            <exports-list-unbound
              :isShow.sync="isShowExportsList"
              :stageUuid="stageUuid"
              @callback="handleExportAddCallback"
            >
            </exports-list-unbound>
          </template>

          <yioks-loading v-if="isShowPageLoading" :h="'462px'" />

          <yioks-empty
            v-if="!isShowPageLoading && !pageList.length"
            tips="暂时没有数据，"
            name="点击添加专家"
            @callback="handleEmptyAction"
          ></yioks-empty>
          <template v-if="isShowDeleteConfirm">
            <yioks-tips
              :showTip="isShowDeleteConfirm"
              tipMsg="确认解除当前专家吗？"
              @callback="handleDeleteCallback"
            ></yioks-tips>
          </template>
          <yioks-pagination :page.sync="page" :total="total"></yioks-pagination>
        </div>
      </div>
    </template>
  </Content>
</template>

<script>
import {
  getBoundExportsListForStage,
  deleteExportForStage,
} from "@/api/export";

export default {
  components: {
    Content: () => import("@/components/layout/list"),
    "yioks-tips": () => import("@/components/YioksTip"),
    "exports-list-unbound": () =>
      import("@/views/performance/allocation/DialogForExportsUnBound"),
  },

  data() {
    return {
      filterData: {
        key: "",
      },
      pageList: [],

      isShowPageLoading: false,
      isShowEmpty: false,
      page: 0,
      pageSize: 20,
      total: 0,
      isShowExportsList: false,

      isShowDeleteConfirm: false,
      deleteRow: {},
    };
  },

  computed: {
    stageUuid() {
      const { stageUuid } = this.$route.query;
      return stageUuid || "";
    },
  },
  watch: {
    page() {
      this.changeQuery();
    },
  },

  created() {
    this.changeQuery(true);
  },

  methods: {
    handleEmptyAction() {
      this.isShowExportsList = true;
    },

    handleAllocation(row, path) {
      const { stageUuid, expertUuid, idName } = row;
      this.$router.push({
        path: path,
        query: {
          stageUuid: stageUuid,
          expertUuid: expertUuid,
          idName: idName,
        },
      });
    },
    changeQuery(flag) {
      flag && (this.page = 0);
      this.$router.replace({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          ...this.filterData,
          page: this.page,
        },
      });
      this.loadPageList();
    },

    loadPageList() {
      const paramsData = {
        ...this.filterData,
        stageUuid: this.stageUuid,
        page: this.page,
        size: this.pageSize,
      };
      this.isShowPageLoading = true;
      getBoundExportsListForStage(paramsData)
        .then((res) => {
          this.isShowPageLoading = false;
          if (res.code) {
            this.$msssage.error(res.msg);
            return;
          }
          const { content, totalElements } = res;
          this.pageList = content;
          this.total = totalElements;
        })
        .catch((err) => {
          this.isShowPageLoading = false;
          console.error("err", err);
        });
    },

    handleExportAddCallback(dialogStatus, callBackStatus) {
      if (dialogStatus) {
        if (callBackStatus) {
          this.changeQuery(true);
          this.$message.success("分配成功！");
        }
        this.isShowExportsList = false;
      } else {
        this.isShowExportsList = false;
      }
    },

    handleDeleteExport(row) {
      this.deleteRow = row;
      this.isShowDeleteConfirm = true;
    },

    handleDeleteCallback(ok) {
      if (ok) {
        const { expertUuid, stageUuid } = this.deleteRow;
        deleteExportForStage({
          expertUuid,
          stageUuid,
        })
          .then((res) => {
            if(res.code) {
              this.$message.error(res.msg);
              return
            }
            this.changeQuery(true);
          })
          .catch((err) => {
            console.error("err", err);
          });
      }
      this.isShowDeleteConfirm = false;
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
@import '~@/assets/css/yioks_page_table'
.table
  .td, .th
    flex 1
.m5
  margin 0 5px
.seq
  flex none !important
  width 6%
</style>
